import debug from 'debug';
import BaseComponent from 'Global/Shared/Components/BaseComponent/BaseComponent';
import { cookieService } from 'Global/Shared/Components/CookieService/CookieService';
import Debounce from 'Global/Shared/Components/Debounce/Debounce';
import lukSolidSvg from 'Minetilbud/Shared/Icons/luk_solid.svg';

const log = debug('NoticePopup');
const debounce = new Debounce().debounce;

class NoticePopup extends BaseComponent {
	constructor(element) {
		super(element);

		this.closeEvent = this.closeHandler.bind(this);
		this.resizeEvent = this.resizeHandler.bind(this);
		this.resizeHandler = debounce(this.resizeHandler, 250);

		this.initialize();
	}

	addSvgIcon() {
		this.dom.close.insertAdjacentHTML('afterbegin', lukSolidSvg);
	}

	async closeHandler(event) {
		event.preventDefault();
		this.element.classList.add('o-notice-popup--hidden');
		
		await this.sleep(1000);

		this.element.parentNode.removeChild(this.element);
		this.setCookie();
	}

	eventListeners() {
		this.dom.close.addEventListener('click', this.closeEvent, false);
		window.addEventListener('resize', this.resizeEvent, false);
	}

	async fadeIn() {
		await this.sleep(500);
		this.element.classList.remove('o-notice-popup--hidden');
	}

	getCookieKey() {
		const path = location.pathname;
		const names = path.split('/');

		this.cookieKey = 'notice-popup';
		
		if (names.length === 0) return;
		
		const name = names[names.length - 1];
		if (name.length > 0) {
			this.cookieKey = 'notice-popup-' + name;
		}
	}

	/**
	 * @returns {Object} settings [catalogId, customerId]
	 */
	 getSettings() {
		let settings = {};

		try {
			settings = JSON.parse(this.element.getAttribute('data-settings'));
			log('getSettings()', settings);
			this.settings = settings;
		} catch (error) {
			log('getSettings() - error', error);
			settings = null;
		}

		return settings;
	}

	initialize() {
		if (this.getSettings() === null) return;
		this.getCookieKey();
		if (this.isHidden()) return;
		this.initDomCache();
		// this.setHeight();
		this.addSvgIcon();
		this.setBackgroundColor();
		this.eventListeners();
		this.fadeIn();
	}

	isHidden() {
		const seen = cookieService.Get(this.cookieKey, 1);
		log('isHidden()', seen);

		if (seen) {
			log('isHidden() - Not showing because of existing cookie');
			return true;
		}

		return false;
	}

	setBackgroundColor() {
		if (this.settings.backgroundColor !== '') {
			this.element.style.backgroundColor = this.settings.backgroundColor;
		}
	}

	setCookie() {
		cookieService.Set({
			name: this.cookieKey,
			value: true,
			type: 1
		});
	}

	setHeight() {
		const width = window.innerWidth;
		if (width < 450) {
			const height = window.innerWidth * 2 / 3;
			this.element.style.height = `${height}px`;
		} else {
			this.element.style.height = `300px`;
		}
	}

	resizeHandler() {
		// this.setHeight();
	}

	sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}
}

export default NoticePopup;
